import { TimePicker } from "@blueprintjs/datetime";
import { FormikProps, getIn } from "formik";
import { FGCustomInput, IFGFormGroupProps } from "nsitools-react";
import * as React from "react";
import { parse } from "date-fns";
export interface IFGHourInputProps
  extends Omit<IFGFormGroupProps, "children"> {}

export const FGHourInput: React.FunctionComponent<IFGHourInputProps> = (
  props
) => {
  const setValue = React.useCallback(
    (formik: FormikProps<any>, value: Date) => {
      formik.setFieldValue(props.name, value);
    },
    [props.name]
  );
  return (
    <FGCustomInput name={props.name} label={props.label}>
      {({ formik, editMode }) => (
        <TimePicker
          value={getIn(formik.values, props.name)}
          onChange={(v) => setValue(formik, v)}
          disabled={props.readonly || !editMode}
        />
      )}
    </FGCustomInput>
  );
};
